import { InfoBox } from '@/components/sv/info-box'
import { Card, CardContent } from '@/components/ui/card'
import { Skeleton } from '@/components/ui/skeleton'
import { cn } from '@/lib/utils'
import * as Styled from '@/routes/app/tabs/deployment/styles'

export const AppDeployDetailsFallback = () => {
  return (
    <Card className="py-4">
      <CardContent>
        <Styled.DeploymentDetailsGrid>
          {new Array(7).fill(null).map((_, index) => (
            <InfoBox
              className={cn({ 'col-span-3': index === 5 || index === 6 })}
              key={index}
              label={<Skeleton className="h-4 w-24" />}
              value={
                <Skeleton
                  className={cn('h-6 w-43', {
                    'w-58': index === 6,
                    'w-64': index === 5,
                    'w-25': index === 4,
                    'w-32': index === 3,
                    'w-28': index === 2,
                    'w-22': index <= 1,
                  })}
                />
              }
            />
          ))}
        </Styled.DeploymentDetailsGrid>
      </CardContent>
    </Card>
  )
}
